import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const AdminSteps = ({ active, label }) => {
  let run = localStorage.getItem('run');
  return (
    <div className="admin-steps">
      <Link to={'/administer/' + run + '/assignment'} className={`btn btn-ter ${active == 0 ? 'active' : null}`}>
        {label}
      </Link>
      <Link to={'/administer/' + run + '/classes'} className={`btn btn-ter ${active == 1 ? 'active' : null}`}>
        Classes
      </Link>
      <Link to={'/administer/' + run + '/students'} className={`btn btn-ter ${active == 2 ? 'active' : null}`}>
        Students
      </Link>
      <Link to={'/administer/' + run + '/groups'} className={`btn btn-ter ${active == 3 ? 'active' : null}`}>
        Groups
      </Link>
    </div>
  );
};

AdminSteps.propTypes = {
  active: PropTypes.string.isRequired
};

export default AdminSteps;



// WEBPACK FOOTER //
// ./src/components/common/AdminSteps.js